import { render, staticRenderFns } from "./DashboardTodayMaintenance.vue?vue&type=template&id=2f4549fe"
import script from "./DashboardTodayMaintenance.vue?vue&type=script&lang=ts"
export * from "./DashboardTodayMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports